import { Component, OnInit, ChangeDetectorRef, Input, ViewChild, ViewChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap';
import { Observable, from } from 'rxjs';
import moment from 'moment';
import momentTImezone from 'moment-timezone';
import { AuthService } from 'src/app/core/services/auth.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { BrowserService } from 'src/app/core/services/browser.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { UserService } from 'src/app/core/services/user.service';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { ScheduleJobMatchItemActionsModalComponent } from './schedule-job-match-item-actions-modal/schedule-job-match-item-actions-modal.component';
import { TIMEZONE_TO_COUNTRY } from '../send-assessment/timezone-country-map';

interface TimezoneOption {
    name: string;
    offset: number;
    displayText: string;
    group: string;
}

@Component({
    selector: 'schedule-job-match-item',
    templateUrl: './schedule-job-match-item.component.html',
    styleUrls: ['./schedule-job-match-item.component.css']
})

export class ScheduleJobMatchItemComponent implements OnInit {
    @ViewChild('scheduleForm') scheduleForm!: NgForm;
    @ViewChildren('userForm') userForms!: QueryList<NgForm>;
    @Input() jobMatchObject: any;
    @Input() jobLocation!: string;
    @Input() itemType!: string;
    @Input() jobMatchId!: string;
    @Input() mode!: string;
    @Input() sourceScreen: any;
    @Input() formalizeActivityPayload: any;
    @Input() jobId: any;
    @Output() saveCallback = new EventEmitter<any>();

    scheduleData: any;
    selectedUserObject: any;
    selectedUserObjectsArray: any[] = [];
    externalNotesAction: any;
    userSearchPlaceholder = '';
    itemDisplayLabel = '';
    usersListLabel = '';
    userTypeLabel = '';
    scheduleLabel = '';
    noEditableMeetingsLabel = '';
    companyName = '';
    companyId: any;
    clientName = '';
    clientId: any;
    sharedReqUserFromCorpOrBuOrVendor = '';
    sharedReqCorporationName = '';
    sharedReqBUName = '';
    sharedReqVendorName = '';
    chosenMeeting: any;
    clientorbulist: any[] = [];
    meetingsList: any[] = [];
    startDate: any;
    startTime: any;
    endDate: any;
    endTime: any;
    browserTimeZone: any;
    addUserTabIndex = 0;
    buList: any[] = [];
    meetingModes: any = [];
    poc: any;
    copyNote: any;
    timezoneChoices: TimezoneOption[] = [];

    viewMode = false;
    savingFlag = false;
    editModeFlag = false;
    showFormFlag = false;
    loadingFlag = false;
    isCorporateFlag = false;
    editableMeetingsExistFlag = false;
    userSearchFlag = true;
    showAddUserOptionFlag = true;
    canAddUserAtCompanyLevel = false;
    canAddUserAtClientOrBULevel = false;
    isUserVendor = false;
    isSharedRequisitionAccessedByVendor = false;
    showTagsInput = true;
    isFirstModifyScheduleTimeCall = false;
    invalidStartDateTime = false;
    invalidEndDateTime = false;
    invalidStartEndTime = false;
    _validatingScheduleDateTime = false;
    tabsLoaded = true;
    isBURequired = false;
    showUserDetailsFlag = false;

    constructor(
        private authService: AuthService,
        private bsModalService: BsModalService,
        private modalService: AngularModalService,
        private browserService: BrowserService,
        private dateTimeUtilityService: DateTimeUtilityService,
        private jobMatchService: JobMatchService,
        private jobService: JobService,
        private userService: UserService,
        private userRoleService: UserRoleService,
        private employeeService: EmployeeService,
        private meetingService: MeetingService,
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.jobId = null;
        this.scheduleData = {
            isCompany: true,
            jobMatchId: '',
            company: '',
            feedbackType: 'SINGLE',
            note: '',
            externalNote: '',
            startDateTime: '',
            endDateTime: '',
            timeZoneName: '',
            meetingMode: 'VIDEO',
            link: '',
            users: [],
            jobLocation: this.jobLocation
        };
        this.selectedUserObject = undefined;
        this.selectedUserObjectsArray = [];
        this.externalNotesAction = {};
        this.userSearchPlaceholder = 'Type first name or last name or email to search.';
        this.itemDisplayLabel = '';
        this.usersListLabel = '';
        this.userTypeLabel = '';
        this.scheduleLabel = 'Schedule';
        this.noEditableMeetingsLabel = '';
        this.companyName = '';
        this.companyId = '';
        this.clientName = '';
        this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
        this.sharedReqCorporationName = '';
        this.sharedReqBUName = '';
        this.sharedReqVendorName = '';
        this.chosenMeeting = '';
        this.clientorbulist = [];
        this.meetingsList = [];
        this.startDate = '';
        this.startTime = '';
        this.endDate = '';
        this.endTime = '';
        this.browserTimeZone = null;
        this.addUserTabIndex = 0;
        this.buList = [];
        this.meetingModes = [];
        //flags
        this.viewMode = false;
        this.savingFlag = false;
        this.editModeFlag = false;
        this.showFormFlag = false;
        this.loadingFlag = false;
        this.isCorporateFlag = false;
        this.editableMeetingsExistFlag = false;
        this.userSearchFlag = true;
        this.showAddUserOptionFlag = true;
        this.canAddUserAtCompanyLevel = false;
        this.canAddUserAtClientOrBULevel = false;
        this.isUserVendor = false;
        this.isSharedRequisitionAccessedByVendor = false;
        this.showTagsInput = true;
        this.isFirstModifyScheduleTimeCall = false;
        this.invalidStartDateTime = false;
        this.invalidEndDateTime = false;
        this.invalidStartEndTime = false;
        this.tabsLoaded = true;
        this.isBURequired = false

        const userDetails = this.authService.getUserDetails();
        this.companyId = userDetails.company.companyId;
        this.isCorporateFlag = (userDetails.company.companyType == 'Corporation');
        this.browserTimeZone = this.dateTimeUtilityService.guessBrowserTimeZoneName();
        this._initializeTimezones();
        this._getMeetingModes();
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            this._getBelongsToBu();
        }
        if (this.mode == 'edit') {
            this.editModeFlag = true;
            this.scheduleLabel = 'Modify';
            this.getScheduledItems();
        } else {
            this.showFormFlag = true;
        }
        if (this.isCorporateFlag) {
            if (this.jobMatchObject.isSharedRequisition && !this.editModeFlag) {
                this._getPocOnJob();
            }
            let searchObject = {
                'searchText': '',
                'companyId': this.companyId
            };
            this.scheduleData.isCompany = this.jobMatchObject.isCorporateLevelRequisition;
            if (!this.scheduleData.isCompany) {
            }

        } else if (!this.isCorporateFlag && this.jobMatchObject.isSharedRequisition && !this.editModeFlag) {
            this.isUserVendor = true;
            this.showUserDetailsFlag = true;
            this._getPocOnJob();
        }
        this.scheduleData.jobMatchId = this.jobMatchId;
        this.scheduleData.company = this.companyId;
        this.jobId = this.jobMatchObject.jobMatchJobId;
        this.companyName = userDetails.company.companyName;
        this.clientName = this.jobMatchObject.jobMatchClientName;
        this.clientId = this.jobMatchObject.jobMatchClientId;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.sharedReqCorporationName = this.jobMatchObject.corporateCompanyName;
            this.sharedReqBUName = this.jobMatchObject.clientOrBUName;
            this.sharedReqVendorName = this.companyName;
            if (this.jobMatchObject.isCorporateLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
                this.scheduleData.isCompany = true;
            } else if (this.jobMatchObject.isClientOrBuLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
                this.scheduleData.isCompany = false;
            }
            /*
                in vendor perspective, users can be added only for a vendor when Corp or BU is selected.
                since one of Corp or BU will be selected by default, make the addUser option disabled.
             */
            this.showAddUserOptionFlag = false;
        }
        // determine if add user option is allowed for this user
        if (this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || (this.userRoleService.isLoggedInUserCompanyAdmin() && !this.isCorporateFlag)) {
            // admin user, add user is allowed in all cases
            this.canAddUserAtCompanyLevel = true;
            this.canAddUserAtClientOrBULevel = true;
        } else if (this.isCorporateFlag) {
            this.canAddUserAtCompanyLevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderCorporateOnMeetingSchedule;
            this.canAddUserAtClientOrBULevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderBUOnMeetingSchedule;
        } else {
            let clientsOrBus = [];
            this.userService.getUsersOnlyClientsOrBus(this.companyId, (data) => {
                clientsOrBus = data;
                // for non admin user
                this.userService.getUserRoleEntityScope((data) => {
                    // if scope is
                    if (data.allclientOrBU) {
                        this.canAddUserAtCompanyLevel = true;
                        this.canAddUserAtClientOrBULevel = true;
                    } else if (clientsOrBus.length) {
                        this.canAddUserAtCompanyLevel = false;
                        if (_.findIndex(clientsOrBus, { companyId: this.clientId }) == -1) {
                            this.canAddUserAtClientOrBULevel = false;
                        } else {
                            this.canAddUserAtClientOrBULevel = true;
                        }
                    } else {
                        this.canAddUserAtCompanyLevel = false;
                        this.canAddUserAtClientOrBULevel = false;
                    }
                }, (error) => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }

        switch(this.itemType) {
            case 'recruiterScreening':
                this.itemDisplayLabel = 'Recruiter Screening';
                this.usersListLabel = 'Select Recruiter Screening';
                this.userTypeLabel = 'Recruiter Screener';
                this.noEditableMeetingsLabel = "No 'Scheduled' Recruiter Screenings are available to modify !";
                break;
            case 'phoneScreen':
                this.itemDisplayLabel = 'Phone Screen';
                this.usersListLabel = 'Select Phone Screen';
                this.userTypeLabel = 'Phone Screener';
                this.noEditableMeetingsLabel = "No 'Scheduled' Phone Screens are available to modify !";
                break;
            case 'interview':
                this.itemDisplayLabel = 'Interview';
                this.usersListLabel = 'Select Interview';
                this.userTypeLabel = 'Interviewer';
                this.noEditableMeetingsLabel = "No 'Scheduled' Interviews are available to modify !";
                break;
        }
        if (!this.editModeFlag) {
            this.scheduleData.note = "Scheduling " + this.itemDisplayLabel;
        }
        if (!this.scheduleData.timeZoneName) {
            this.scheduleData.timeZoneName = this._toCanonicalZoneName(this.browserTimeZone);
        }
        // the form inputs are not in the DOM until the first render has run
        setTimeout(() => this._initializeDateAndTimePickers());
        // to disable chrome autocomplete of the type ahead field.
        setTimeout(() => {
            if (this.browserService.isGoogleChrome()) {
                $("[placeholder='" + this.userSearchPlaceholder + "']").attr("autocomplete", "nope");
            }
        }, 200);
    }

    _getBelongsToBu() {
        this.userService.getUserBelongsTo(this.companyId, '', '', (data) => {
            this.buList = data.buInfos;
            this.isBURequired = !data.belongsToCorp;
        }, (error) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    timezoneSearchFn(term: string, item: TimezoneOption): boolean {
        const normalizedTerm = term.toLocaleLowerCase();
        return item.displayText.toLocaleLowerCase().indexOf(normalizedTerm) > -1 ||
            item.group.toLocaleLowerCase().indexOf(normalizedTerm) > -1;
    }

    _toCanonicalZoneName(zoneName: string): string {
        if (!zoneName || TIMEZONE_TO_COUNTRY[zoneName]) {
            return zoneName;
        }
        const links = (momentTImezone as any).tz._links;
        const names = (momentTImezone as any).tz._names;
        const key = zoneName.toLowerCase().replace(/\//g, '_');
        const linkedKey = links && links[key];
        const linkedName = linkedKey && names && names[linkedKey];
        return (linkedName && TIMEZONE_TO_COUNTRY[linkedName]) ? linkedName : zoneName;
    }

    _initializeTimezones() {
        this.timezoneChoices = (momentTImezone as any).tz.names().map(zone => {
            const zoneMoment = (momentTImezone as any).tz(zone);
            const offset = zoneMoment.utcOffset();
            const country = TIMEZONE_TO_COUNTRY[zone] || 'Other';
            return {
                name: zone,
                offset: offset,
                displayText: `${zone.replace(/_/g, ' ')} (UTC${zoneMoment.format('Z')})`,
                group: `${country}:`
            };
        });
        this.timezoneChoices.sort((a, b) => a.offset - b.offset);
    }

    _getMeetingModes() {
        this.meetingModes = [
            { name: 'Phone', value: 'PHONE' },
            { name: 'Audio', value: 'AUDIO' },
            { name: 'Video', value: 'VIDEO' }
        ];
        if (this.itemType == 'interview') {
            this.meetingModes.push(
                { name: 'Face-to-Face', value: 'FACE_TO_FACE' }
            );
        }
    }

    _getPocOnJob(successCallback?: any): void {
        this.jobService.getPocOnJob(this.jobMatchObject.jobMatchJobId, (data: any) => {
            this._massagePocData(data);
            if (successCallback) {
                successCallback();
            }
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
        });
    }

    _massagePocData(pocDetails) {
        if (!_.isNull(pocDetails.id)) {
            this.poc = this._getUserObject();
            this.poc.bu = pocDetails.buId;
            this.poc.buName = pocDetails.buName ? pocDetails.buName : "Corporate";
            this.poc.emailAddress = pocDetails.email;
            this.poc.firstName = pocDetails.firstName;
            this.poc.lastName = pocDetails.lastName;
            this.poc.phoneNumber = pocDetails.mobilephone;
            this.poc.title = pocDetails.title;
            this.poc.userId = pocDetails.id;
            this.poc.isPoc = true;
            this.scheduleData.users.push(this.poc);
            let tagUser = this._getAutoCompleteUserObject(this.poc);
            this.selectedUserObjectsArray.push(tagUser);
        }
    }

    onFeedbackTypeChange(feedbackType) {
        if (feedbackType == 'SINGLE') {
            angular.forEach(this.scheduleData.users, (user, key) => {
                user.isIndividual = false;
            });
        } else {
            angular.forEach(this.scheduleData.users, (user, key) => {
                user.isIndividual = true;
            });
        }
    }

    schedule() {
        setTimeout(() => {
            if (this.scheduleData.users.length) {
                let uIErrorExists = false;
                // validate the forms
                this.userForms.forEach((userForm) => {
                    userForm.onSubmit(undefined as any);
                    if (userForm.invalid) {
                        uIErrorExists = true;
                    }
                });
                if (!uIErrorExists && !this.scheduleForm.invalid) {
                    this.savingFlag = true;
                    this.scheduleData.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.startDate + ' ' + this.startTime));
                    this.scheduleData.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.endDate + ' ' + this.endTime));
                    if (this.editModeFlag == true) {
                        let rescheduleData: any = {};
                        rescheduleData.startDateTime = this.scheduleData.startDateTime;
                        rescheduleData.endDateTime = this.scheduleData.endDateTime;
                        rescheduleData.companyId = this.scheduleData.company;
                        rescheduleData.note = this.scheduleData.note;
                        rescheduleData.externalNote = this.scheduleData.externalNote;
                        rescheduleData.timeZoneName = this.scheduleData.timeZoneName;
                        rescheduleData.meetingMode = this.scheduleData.meetingMode;
                        this.jobMatchService.rescheduleMeeting(this.chosenMeeting.id, this.scheduleData, (data) => {
                            this.savingFlag = false;
                            if (!_.isUndefined(this.saveCallback)) {
                                this.saveCallback.emit();
                            }
                        }, (error) => {
                            this.savingFlag = false;
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    } else {
                        this.jobMatchService.schedulePhoneScreenOrInterview(this.itemType, this.scheduleData, (data) => {
                            this.savingFlag = false;
                            if (!_.isUndefined(this.saveCallback)) {
                                this.saveCallback.emit();
                            }
                        }, (error) => {
                            this.savingFlag = false;
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                }
            } else if (!this.scheduleForm.invalid) {
                this.alertsAndNotificationsService.showAlertWithCallBack('No Users Selected', "Please select at least one user to schedule " + this.itemDisplayLabel + ".", 'warning', () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                });
            }
        }, 200);
    }

    getScheduledItems() {
        this.loadingFlag = true;
        let loggedInUserId = null;
        if(this.itemType == 'recruiterScreening') {
            this.jobMatchService.getRecruiterScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        } else if(this.itemType == 'phoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        } else {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                this.loadingFlag = false;
                this.meetingsList = this._getMeetingsList(data);
            }, (error) => {
                this.loadingFlag = false;
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    }

    _getMeetingsList(response) {
        let meetingsList = [];
        let workflowStep = 'in';
        if(this.itemType == 'recruiterScreening') {
            workflowStep = 'rs';
        } else if(this.itemType == 'phoneScreen') {
            workflowStep = 'ps';
        }
        angular.forEach(response, (meetingDetails, key) => {
            let meeting: any = {};
            let timeZone = meetingDetails.timeZone;
            if (_.isNull(timeZone)) {
                timeZone = this.browserTimeZone;
            }
            let startDateTime = new Date(meetingDetails.meetingStartTime);
            let endDateTime = new Date(meetingDetails.meetingEndTime);
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            meeting.createdByCompanyId = meetingDetails.company;
            meeting.isCreatedByClient = meeting.createdByCompanyId !== null && meeting.createdByCompanyId !== this.companyId && !this.isCorporateFlag;
            switch (meeting.status) {
                case 'SCHEDULED':
                    meeting.statusClass = 'fa fa-calendar meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'far fa-clock feedback-meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fa fa-hourglass-half meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = false;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = false;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTimeInSelectedTimeZone = moment(startDateTime).tz(timeZone).format("MMM DD, YYYY ( hh:mm a") + ' to ' + moment(endDateTime).tz(timeZone).format("hh:mm a )") + ' in ' + timeZone;
            meeting.scheduledTimeInBrowserTimeZone = null;
            if (timeZone != this.browserTimeZone) {
                meeting.scheduledTimeInBrowserTimeZone = moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + moment(endDateTime).format("hh:mm a )") + " in your Computer's time zone (" + this.browserTimeZone + ")";
            }
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, (meetingUser, k) => {
                let user: any = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                user.isPoc = meetingUser.isPoc;
                meeting.userList.push(user);
                if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                } else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            meetingsList.push(meeting);
        });
        return meetingsList;
    }

    meetingChanged() {
        this.showFormFlag = false;
        this.loadingFlag = true;
        this.showUserDetailsFlag = false;
        this.userSearchFlag = true;
        this.isFirstModifyScheduleTimeCall = true;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.isSharedRequisitionAccessedByVendor = true;
        }
        this._setUserAccessToFeedback(this.chosenMeeting.createdByCompanyId);
        this.jobMatchService.getMeetingDetails(this.chosenMeeting.id, (data) => {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            if (!this.viewMode) {
                angular.forEach(data.participants, (val, key) => {
                    val.emailAddress = val.email;
                    val.userId = val.id;
                    if (_.isNull(val.title)) {
                        val.title = '-';
                    }
                    val.selectedDepartmentObjectsArray = [];
                    if (!_.isNull(val.departmentDetail)) {
                        let department: any = {};
                        department.name = val.departmentDetail.name;
                        department.id = val.departmentDetail.id;
                        val.selectedDepartmentObjectsArray.push(department);
                        val.department = angular.copy(department);
                    }
                    if (!_.isNull(val.bu)) {
                        val.buId = val.bu.id;
                        val.buName = val.bu.name;
                    } else {
                        val.buId = '';
                        val.buName = 'Corporate';
                    }
                    val.isIndividual = data.isIndividual;
                    this.scheduleData.users.push(val);
                });

                angular.forEach(this.scheduleData.users, (val, key) => {
                    let tagUser = this._getAutoCompleteUserObject(val);
                    this.selectedUserObjectsArray.push(tagUser);
                });
                this.addUserTabIndex = 0;
                if (this.isSharedRequisitionAccessedByVendor) {
                    this.showUserDetailsFlag = true;
                    this.userSearchFlag = false;
                    setTimeout(() => {
                        this.addUserTabIndex = 0;
                    }, 100);
                }
            } else {
                this.isUserVendor = true;
                this.showUserDetailsFlag = true;
                this.userSearchFlag = false;
                this._getPocOnJob(() => {
                    this.showUserDetailsFlag = true;
                    setTimeout(() => {
                        this.addUserTabIndex = 0;
                    }, 100);
                });
            }

            this.scheduleData.note = data.note;
            this.scheduleData.externalNote = data.externalNote;
            this.scheduleData.feedbackType = data.feedbackType;
            this.scheduleData.company = this.companyId;
            this.scheduleData.isCompany = data.isCompany;
            this.scheduleData.meetingMode = data.meetingMode;
            this.scheduleData.link = data.link;
            if (data.location !== null && data.location.city !== null) {
                data.location.city = data.location.city.name;
                this.scheduleData.jobLocation = this.jobService.getParsedJobLocationText(data.location, false);
            }

            if (!_.isNull(data.timeZoneName)) {
                this.scheduleData.timeZoneName = this._toCanonicalZoneName(data.timeZoneName);
            }
            // The date/time inputs are inside the showFormFlag block, so render them and build the
            // pickers before the values below are pushed into them.
            this.showFormFlag = true;
            this.changeDetectorRef.detectChanges();
            this._initializeDateAndTimePickers();

            if (!_.isNull(data.timeZoneName)) {
                // if time zone information exists
                this.scheduleData.timeZoneName = this._toCanonicalZoneName(data.timeZoneName);
                // get the time stamp string in the relevant time zone.
                let currentDateTimeStringInSelectedTimeZone = new Date(moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));
                let startDateTimeStringInSelectedTimeZone = moment(data.startTime).tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
                let endDateTimeStringInSelectedTimeZone = moment(data.endTime).tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
                let startDateTime = new Date(startDateTimeStringInSelectedTimeZone);
                let endDateTime = new Date(endDateTimeStringInSelectedTimeZone);

                ($("#jobMatchScheduleStartDate") as any).datepicker("setDate", startDateTime);
                ($("#jobMatchScheduleStartDate") as any).datepicker("setStartDate", currentDateTimeStringInSelectedTimeZone);
                ($("#jobMatchScheduleStartDate") as any).datepicker("update", moment(startDateTime).format("MMM DD, YYYY"));
                this.startDate = moment(startDateTime).format("MMM DD, YYYY");
                ($("#jobMatchScheduleEndDate") as any).datepicker("setDate", endDateTime);
                ($("#jobMatchScheduleEndDate") as any).datepicker("setStartDate", startDateTime);
                ($("#jobMatchScheduleEndDate") as any).datepicker("update", moment(endDateTime).format("MMM DD, YYYY"));
                this.endDate = moment(endDateTime).format("MMM DD, YYYY");
                ($("#jobMatchScheduleStartTime") as any).timepicker("setTime", this._getTimeStringInAMPMFormat(startDateTime));
                this.startTime = this._getTimeStringInAMPMFormat(startDateTime);
                ($('#jobMatchScheduleEndTime') as any).timepicker("setTime", this._getTimeStringInAMPMFormat(endDateTime));
                this.endTime = this._getTimeStringInAMPMFormat(endDateTime);
            } else {
                let currentDateTime = new Date();
                let startDateTime = new Date(data.startTime);
                let endDateTime = new Date(data.endTime);
                // if(startDateTime > currentDateTime) {
                ($("#jobMatchScheduleStartDate") as any).datepicker("setDate", startDateTime);
                ($("#jobMatchScheduleStartDate") as any).datepicker("setStartDate", currentDateTime);
                ($("#jobMatchScheduleStartDate") as any).datepicker("update", moment(startDateTime).format("MMM DD, YYYY"));
                this.startDate = moment(startDateTime).format("MMM DD, YYYY");
                ($("#jobMatchScheduleEndDate") as any).datepicker("setDate", endDateTime);
                ($("#jobMatchScheduleEndDate") as any).datepicker("setStartDate", startDateTime);
                ($("#jobMatchScheduleEndDate") as any).datepicker("update", moment(endDateTime).format("MMM DD, YYYY"));
                this.endDate = moment(endDateTime).format("MMM DD, YYYY");
                ($('#jobMatchScheduleStartTime') as any).timepicker("setTime", this._getTimeStringInAMPMFormat(startDateTime));
                this.startTime = this._getTimeStringInAMPMFormat(startDateTime);
                ($('#jobMatchScheduleEndTime') as any).timepicker("setTime", this._getTimeStringInAMPMFormat(endDateTime));
                this.endTime = this._getTimeStringInAMPMFormat(endDateTime);
                // } else {
                // the defaults will load.
                // }
            }
            setTimeout(() => {
                this.isFirstModifyScheduleTimeCall = false;
            }, 2000);
            this.showFormFlag = true;
            this.loadingFlag = false;
        }, (error) => {
            this.loadingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _setUserAccessToFeedback(scheduleCreatedByCompanyId) {
        this.viewMode = scheduleCreatedByCompanyId !== null && scheduleCreatedByCompanyId !== this.companyId && !this.isCorporateFlag;
    }

    _getAutoCompleteUserObject(val) {
        let tagUser: any = {};
        tagUser.displayString = val.firstName;
        tagUser.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
        tagUser.displayString += ' - ' + val.emailAddress;
        tagUser.id = val.userId;
        tagUser.firstName = val.firstName;
        tagUser.lastName = val.lastName;
        tagUser.email = val.emailAddress;
        tagUser.title = val.title;
        tagUser.mobilephone = val.phoneNumber;
        tagUser.isIndividual = val.isIndividual;
        tagUser.isPoc = val.isPoc;
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            tagUser.buId = val.buId;
            tagUser.buName = val.buName;
        } else {
            tagUser.departmentName = val.department;
        }
        return tagUser;
    }

    _getTimeStringInAMPMFormat(date) {
        return moment(date).format("hh:mm A");
    }

    _validateAndCorrectStartDateTimeAndEndDateTime() {
        // setTime/setDate below fire the picker's own change event synchronously, which is wired
        // back to this same method - without a reentrancy guard that can recurse until the call
        // stack overflows (seen as "Maximum call stack size exceeded" in String.replace, which the
        // datepicker/timepicker plugins use internally to format the value on every set call).
        if (this._validatingScheduleDateTime) {
            return;
        }
        this._validatingScheduleDateTime = true;
        try {
            this._doValidateAndCorrectStartDateTimeAndEndDateTime();
        } finally {
            this._validatingScheduleDateTime = false;
        }
    }

    _doValidateAndCorrectStartDateTimeAndEndDateTime() {
        let currentDateTimeStringInSelectedTimeZone = moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let momentOfCurrentDateTime = moment(currentDateTimeStringInSelectedTimeZone);
        const nowInSelectedTimeZone = momentOfCurrentDateTime.toDate();
        let currentStartDateTime = new Date(this.startDate + ' ' + this.startTime);
        let momentOfCurrentStartDateTime = moment(currentStartDateTime);
        let currentEndDateTime = new Date(this.endDate + ' ' + this.endTime);
        // if the start date is same as the current date
        let startDateAndCurrentDateAreSameFlag = momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'day');
        // if the start hours are less than current hours
        let startHoursLessThanCurrentHoursFlag = momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'hour');
        // if the hours are equal but minutes are less than current minutes.
        let hoursEqualButStartMinutesLessThanCurrentMinutesFlag = (momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'hour') && momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'minute'));
        this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
        this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentEndDateTime;

        //Do not update date time when modifying schedule is rendered
        if (!this.isFirstModifyScheduleTimeCall) {
            // this.invalidEndDateTime = false;
            this.invalidStartEndTime = false;
            if (startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag)) {
                let currentDateRoundedToTheHour = momentOfCurrentDateTime.minute() || momentOfCurrentDateTime.second() || momentOfCurrentDateTime.millisecond() ? momentOfCurrentDateTime.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDateTime.startOf('hour').toDate();
                ($("#jobMatchScheduleStartTime") as any).timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateRoundedToTheHour));
                this.startTime = ($("#jobMatchScheduleStartTime") as any).val();
                // the corrected start is what is shown now; checking the stale one left the error up
                // with nothing left to change, since re-picking the same time fires no change event
                const correctedStartDateTime = new Date(this.startDate + ' ' + this.startTime);
                this.invalidStartDateTime = nowInSelectedTimeZone > correctedStartDateTime;
                this.invalidEndDateTime = nowInSelectedTimeZone > currentEndDateTime;
            } else if (currentStartDateTime >= currentEndDateTime) {
                // after the change to 'start time', check if the existing 'end time' component keeps 'end date time' as greater than 'start date time'
                // if not, make the 'end time' 30 mins greater than current start time.
                let currentStartDateTimePlus30Minutes = momentOfCurrentStartDateTime.add('30', 'minutes').toDate();
                ($("#jobMatchScheduleEndDate") as any).datepicker("setDate", currentStartDateTimePlus30Minutes);
                ($("#jobMatchScheduleEndDate") as any).datepicker("update", moment(currentStartDateTimePlus30Minutes).format("MMM DD, YYYY"));
                this.endDate = ($("#jobMatchScheduleEndDate") as any).val();
                ($('#jobMatchScheduleEndTime') as any).timepicker("setTime", this._getTimeStringInAMPMFormat(currentStartDateTimePlus30Minutes));
                this.endTime = ($('#jobMatchScheduleEndTime') as any).val();
                setTimeout(() => {
                    this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
                    this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTimePlus30Minutes;
                }, 200);
            } else {
                ($("#jobMatchScheduleStartDate") as any).datepicker("setDate", currentStartDateTime);
                ($("#jobMatchScheduleStartDate") as any).datepicker("update", moment(currentStartDateTime).format("MMM DD, YYYY"));
                this.startDate = ($("#jobMatchScheduleStartDate") as any).val();
                setTimeout(() => {
                    this.invalidStartDateTime = momentOfCurrentDateTime.toDate() > currentStartDateTime;
                    this.invalidEndDateTime = momentOfCurrentDateTime.toDate() > currentEndDateTime;
                }, 300);
            }

            // set the start date of the end date calendar to be the current start date of the start date calendar.
            ($("#jobMatchScheduleEndDate") as any).datepicker("setStartDate", currentStartDateTime);

        } else {
            // Display invalid date time if the schedule is passed
            this.invalidStartEndTime = startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag);
        }
    }

    timeZoneChanged() {
        let currentDateTimeStringInSelectedTimeZone = moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
        let momentOfCurrentDate = moment(currentDate);
        let currentDateTimeRoundedToTheHour = momentOfCurrentDate.minute() || momentOfCurrentDate.second() || momentOfCurrentDate.millisecond() ? momentOfCurrentDate.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDate.startOf('hour').toDate();

        ($("#jobMatchScheduleStartDate") as any).datepicker("setDate", currentDate);
        ($("#jobMatchScheduleStartDate") as any).datepicker("setStartDate", currentDate);
        ($("#jobMatchScheduleStartDate") as any).datepicker("update", moment(currentDate).format("MMM DD, YYYY"));
        this.startDate = moment(currentDate).format("MMM DD, YYYY");
        ($("#jobMatchScheduleEndDate") as any).datepicker("setDate", currentDateTimeRoundedToTheHour);
        ($("#jobMatchScheduleEndDate") as any).datepicker("setStartDate", currentDate);
        ($("#jobMatchScheduleEndDate") as any).datepicker("update", moment(currentDateTimeRoundedToTheHour).format("MMM DD, YYYY"));
        this.endDate = moment(currentDateTimeRoundedToTheHour).format("MMM DD, YYYY");
        ($("#jobMatchScheduleStartTime") as any).timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateTimeRoundedToTheHour));
        this.startTime = this._getTimeStringInAMPMFormat(currentDateTimeRoundedToTheHour);
        ($('#jobMatchScheduleEndTime') as any).timepicker("setTime", this._getTimeStringInAMPMFormat(moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate()));
        this.endTime = this._getTimeStringInAMPMFormat(moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate());
    }

    _initializeDateAndTimePickers() {
        let currentDateTimeStringInSelectedTimeZone = moment().tz(this.scheduleData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
        let momentOfCurrentDate = moment(currentDate);
        let currentDateTimeRoundedToTheHour = momentOfCurrentDate.minute() || momentOfCurrentDate.second() || momentOfCurrentDate.millisecond() ? momentOfCurrentDate.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDate.startOf('hour').toDate();

        ($('#jobMatchScheduleStartDate') as any).datepicker({
            format: "M d, yyyy",
            startDate: currentDateTimeRoundedToTheHour,
            weekStart: 1,
            autoclose: true
        });
        // set current date as default value
        ($("#jobMatchScheduleStartDate") as any).datepicker("setDate", currentDate);
        ($("#jobMatchScheduleStartDate") as any).datepicker("update", moment(currentDate).format("MMM DD, YYYY"));
        this.startDate = moment(currentDate).format("MMM DD, YYYY");

        ($('#jobMatchScheduleEndDate') as any).datepicker({
            format: "M d, yyyy",
            startDate: currentDateTimeRoundedToTheHour,
            weekStart: 1,
            autoclose: true
        });

        ($("#jobMatchScheduleEndDate") as any).datepicker("setDate", currentDateTimeRoundedToTheHour);
        ($("#jobMatchScheduleEndDate") as any).datepicker("update", moment(currentDateTimeRoundedToTheHour).format("MMM DD, YYYY"));
        this.endDate = moment(currentDateTimeRoundedToTheHour).format("MMM DD, YYYY");

        ($('#jobMatchScheduleStartTime') as any).timepicker({
            minuteStep: 5,
            showSeconds: false,
            showMeridian: true,
            disableFocus: true,
            defaultTime: currentDateTimeRoundedToTheHour
        });
        this.startTime = this._getTimeStringInAMPMFormat(currentDateTimeRoundedToTheHour);

        ($('#jobMatchScheduleEndTime') as any).timepicker({
            minuteStep: 5,
            showSeconds: false,
            showMeridian: true,
            disableFocus: true,
            defaultTime: moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate()
        });
        this.endTime = this._getTimeStringInAMPMFormat(moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate());

        ($('#jobMatchScheduleStartDate') as any).datepicker().on('changeDate', (e) => {
            // bootstrap-datepicker syncs via a native 'change' event, which Angular's
            // ngModel does not listen for on text inputs (only 'input') - read the
            // picker's value directly so the model isn't left stale.
            this.startDate = ($('#jobMatchScheduleStartDate') as any).val();
            this._validateAndCorrectStartDateTimeAndEndDateTime();
        });

        ($('#jobMatchScheduleEndDate') as any).datepicker().on('changeDate', (e) => {
            this.endDate = ($('#jobMatchScheduleEndDate') as any).val();
            this._validateAndCorrectStartDateTimeAndEndDateTime();
        });

        ($('#jobMatchScheduleStartTime') as any).timepicker().on('changeTime.timepicker', (e) => {
            // bootstrap-timepicker syncs via a native 'change' event too - same fix as above.
            this.startTime = ($('#jobMatchScheduleStartTime') as any).val();
            this._validateAndCorrectStartDateTimeAndEndDateTime();
        });

        ($('#jobMatchScheduleEndTime') as any).timepicker().on('changeTime.timepicker', (e) => {
            this.endTime = ($('#jobMatchScheduleEndTime') as any).val();
            this._validateAndCorrectStartDateTimeAndEndDateTime();
        });

    }

    openDateOrTimePicker(inputId: string) {
        const input = $('#' + inputId) as any;
        if (input.prop('disabled')) {
            return;
        }
        if (/Time$/.test(inputId)) {
            input.timepicker('showWidget');
        } else {
            input.datepicker('show');
        }
    }

    toggleViewUserDetails() {
        this.showUserDetailsFlag = !this.showUserDetailsFlag;
        if (this.showUserDetailsFlag) {
            this.addUserTabIndex = 0;
        }
    }

    public getUsers = (searchTerm: string): Observable<any[]> => {
        let searchObject: any = {
            'companyOrClientBuId': this.scheduleData.isCompany ? this.scheduleData.company : this.clientId,
            'email': searchTerm,
            'firstName': searchTerm,
            'lastName': searchTerm,
            'requisitionId': this.jobId,
            'loggedInCompanyId': this.companyId
        };
        if (this.isSharedRequisitionAccessedByVendor) {
            if (this.sharedReqUserFromCorpOrBuOrVendor == 'Corp') {
                searchObject.companyOrClientBuId = this.jobMatchObject.corporateCompanyId;
            } else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Bu') {
                searchObject.companyOrClientBuId = this.jobMatchObject.clientOrBUId;
            } else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Vendor') {
                searchObject.companyOrClientBuId = this.companyId;
            }
        }
        return from(
            this.userService.getFilteredUsersPromiseForTypeAhead(searchObject).then((data: any) => {
                angular.forEach(data, (val, key) => {
                    val.displayString = val.firstName;
                    val.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
                    val.displayString += ' - ' + val.email;
                    val.buName = val.buName ? val.buName : "Corporate";
                });
                return data;
            })
        );
    }

    _resetScheduleData() {
        _.remove(this.scheduleData.users, (user: any) => {
            return user.isPoc == undefined || user.isPoc == false;
        });
        _.remove(this.selectedUserObjectsArray, (userTag) => {
            return userTag.isPoc == undefined || userTag.isPoc == false;
        });
    }

    addUser() {
        this.scheduleData.users.push(this._getUserObject());
        setTimeout(() => {
            this.addUserTabIndex = this.scheduleData.users.length - 1;
        }, 200);
    }

    addEmployee() {
        $(".modal").addClass("schedule-job-match-meeting-modal-medium");

        setTimeout(() => {
            const config = new ModalConfig();
            config.class = 'custom-modal-65';
            config.backdrop = true;
            config.ignoreBackdropClick = true;
            config.keyboard = false;
            config.initialState = {
                actionType: 'addEmployee',
                actionLabel: 'Add Employee'
            };
            const actionsModal = this.bsModalService.show(ScheduleJobMatchItemActionsModalComponent, config);

            actionsModal.content.onClose.subscribe((data: any) => {
                if (data) {
                    let user = this._getUserObject();
                    user.userId = data.entity.id;
                    user.firstName = data.entity.firstName;
                    user.lastName = data.entity.lastName;
                    user.emailAddress = data.entity.email;
                    user.title = data.entity.title;
                    user.phoneNumber = data.entity.phoneNumber;
                    user.department = data.entity.department;
                    user.buId = data.entity.buId;
                    user.isIndividual = false;
                    user.buName = data.entity.bu ? data.entity.bu.name : "Corporate";
                    user.selectedDepartmentObjectsArray = data.entity.department ? [{ id: data.entity.department.id, name: data.entity.department.name }] : [];
                    this.scheduleData.users.push(user);
                    let tagUser = this._getAutoCompleteUserObject(user);
                    this.selectedUserObjectsArray.push(tagUser);
                    setTimeout(() => {
                        this.addUserTabIndex = this.scheduleData.users.length - 1;
                    }, 200);
                }
                setTimeout(() => {
                    $(".modal").removeClass("schedule-job-match-meeting-modal-medium");
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }, 600);
            });
        }, 300);
    }

    removeUser($index) {
        this.tabsLoaded = false;
        this.scheduleData.users.splice($index, 1);
        setTimeout(() => {
            this.addUserTabIndex = 0;
            this.tabsLoaded = true;
        }, 1000);
    }

    getUserForm(index: number): NgForm | null {
        return this.userForms ? this.userForms.toArray()[index] : null;
    }

    _getUserObject() {
        let user: any = {};
        user.userId = null;
        user.temporaryUserId = Math.floor((Math.random() * 100) + 1).toString();
        user.firstName = '';
        user.lastName = '';
        user.emailAddress = '';
        user.title = '';
        user.phoneNumber = '';
        user.department = null;
        user.buId = '';
        user.buName = '';
        user.department = null;
        user.isIndividual = false;
        user.selectedDepartmentObjectsArray = [];
        return user;
    }

    userTypeChanged() {
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }

        if (!this.userSearchFlag && !this.scheduleData.users.some(user => user.userId == null)) {
            this.addUser();
        }
        (this.scheduleForm as any)._submitted = false;
    }

    _removeCreatedUsers() {
        _.remove(this.scheduleData.users, (user: any) => {
            return user.userId == null;
        });
    }

    companyClientUserTypeChanged(userType) {
        let usersCount = this.scheduleData.users.length;
        if (usersCount == 0 || (usersCount == 1 && this.scheduleData.users[0].isPoc) || this.isCorporateFlag) {
            this._switchCompanyClient();
        } else {
            this._showCompanyClientUsersRemoveWarning(userType);
        }
    }

    _showCompanyClientUsersRemoveWarning(userType) {
        let message = "The chosen user(s) will be removed. Are you sure you want to continue?";
        this.alertsAndNotificationsService.showConfirm('Confirm', message, 'warning', true, () => {
            this._switchCompanyClient();
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, () => {
            this.scheduleData.isCompany = !this.scheduleData.isCompany;
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    }

    _switchCompanyClient() {
        // reset the schedule data.
        this.showTagsInput = false;
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        if (!this.isCorporateFlag && this.scheduleData.isCompany && !this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
        }
        // if it is staffing company and client is chosen, get poc
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            this._getPocOnJob();
        }
        // if it is staffing company and client is chosen, user cannot be added
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.showAddUserOptionFlag = false;
            // toggle to user search, if not already in search mode
            if (!this.userSearchFlag) {
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        } else {
            this.showAddUserOptionFlag = true;
        }
        if (this.scheduleData.isCompany && !this.canAddUserAtCompanyLevel) {
            // if logged in user cannot add users at company level
            this.userSearchFlag = true;
            this.userTypeChanged();
        } else if (!this.scheduleData.isCompany && !this.canAddUserAtClientOrBULevel) {
            // if logged in user cannot add users are client/Bu level
            this.userSearchFlag = true;
            this.userTypeChanged();
        }

        setTimeout(() => {
            this.showTagsInput = true;
        }, 1000)
    }

    corpBuVendorUserTypeChanged(userType) {
        let usersCount = this.scheduleData.users.length;
        if (usersCount == 0 || (usersCount == 1 && this.scheduleData.users[0].isPoc)) {
            this._switchCorpBu();
        } else {
            this._showCorpBuUsersRemoveWarning(userType);
        }
    }

    _showCorpBuUsersRemoveWarning(userType) {
        let message = "The chosen user(s) will be removed. Are you sure you want to cancel?";
        this.alertsAndNotificationsService.showConfirm('Confirm', message, 'warning', true, () => {
            this._switchCorpBu();
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, () => {
            if (userType == 'Corporation') {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
            } else {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
            }
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    }

    _switchCorpBu() {
        // reset the schedule data.
        this._resetScheduleData();
        if (this.sharedReqUserFromCorpOrBuOrVendor == 'Corp') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.jobMatchObject.corporateCompanyId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = false;
            this.userSearchFlag = true;
            this.userTypeChanged();
            if (this.isUserVendor) {
                this._showPocDetails();
            }
        } else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Bu') {
            this.scheduleData.isCompany = false;
            this.scheduleData.company = this.jobMatchObject.clientOrBUId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = false;
            this.userSearchFlag = true;
            this.userTypeChanged();
            if (this.isUserVendor) {
                this._showPocDetails();
            }
        } else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Vendor') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.companyId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = true;
            if (!this.canAddUserAtCompanyLevel) {
                // if logged in user cannot add users are company level
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        }
    }

    _showPocDetails() {
        this.scheduleData.users.push(this.poc);
        this.showUserDetailsFlag = true;
        setTimeout(() => {
            this.addUserTabIndex = 0;
        }, 100);
    }

    userTypeAheadUserAdded(tag) {
        this.addUser();
        this.scheduleData.users[this.scheduleData.users.length - 1].userId = tag.id;
        this.scheduleData.users[this.scheduleData.users.length - 1].firstName = tag.firstName;
        this.scheduleData.users[this.scheduleData.users.length - 1].lastName = tag.lastName;
        this.scheduleData.users[this.scheduleData.users.length - 1].emailAddress = tag.email;
        this.scheduleData.users[this.scheduleData.users.length - 1].title = tag.title;
        if (_.isNull(tag.mobilephone)) {
            this.scheduleData.users[this.scheduleData.users.length - 1].phoneNumber = '-';
        } else {
            this.scheduleData.users[this.scheduleData.users.length - 1].phoneNumber = tag.mobilephone;
        }
        if (!_.isNull(tag.role) && tag.role.length > 0) {
            this.scheduleData.users[this.scheduleData.users.length - 1].role = tag.role[this.scheduleData.users.length - 1].description;
        }

        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users[this.scheduleData.users.length - 1].buId = tag.buId;
            this.scheduleData.users[this.scheduleData.users.length - 1].buName = tag.buName;
        } else {
            this.scheduleData.users[this.scheduleData.users.length - 1].department = tag.departmentName;
            if (!_.isNull(tag.departmentName)) {
                let department = { 'id': tag.departmentId, 'name': tag.departmentName };
                this.scheduleData.users[this.scheduleData.users.length - 1].selectedDepartmentObjectsArray = [];
                this.scheduleData.users[this.scheduleData.users.length - 1].selectedDepartmentObjectsArray.push(department);
                this.scheduleData.users[this.scheduleData.users.length - 1].department = department;
            }
        }

        if (this.scheduleData.feedbackType == 'SINGLE') {
            this.scheduleData.users[this.scheduleData.users.length - 1].isIndividual = false;
        } else {
            this.scheduleData.users[this.scheduleData.users.length - 1].isIndividual = true;
        }
    }

    userTypeAheadUserRemoved(tag) {
        if (tag.isPoc) {
            this.selectedUserObjectsArray.unshift(tag);
            this.alertsAndNotificationsService.showAlertWithCallBack('Warning!', 'Point of Contact cannot be removed.', 'warning', () => {
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        } else {
            let removedIndex = _.findIndex(this.scheduleData.users, { userId: tag.id });
            this.scheduleData.users.splice(removedIndex, 1);
        }
    }

    public getDepartments = (searchTerm: string): Observable<any[]> => {
        let searchObject = {
            'searchText': searchTerm,
            'companyId': this.companyId
        };
        return from(
            this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then((data: any) => {
                return data;
            })
        );
    }

    departmentTypeAheadDepartmentAdded(tag, user) {
        user.department = {};
        user.department.name = tag.name;
        if (!_.isNull(tag.id)) {
            user.department.id = tag.id;
        }
    }

    departmentTypeAheadDepartmentRemoved(tag, user) {
        user.department = null;
    }

    onInternalNoteChanged() {
        this.scheduleData.externalNote = this.scheduleData.note;
    }

    onExternalNoteChange(event) {
        this.scheduleData.externalNote = event.externalNote;
    }

    onCopyNoteChange(event) {
        this.copyNote = event.copyNote;
    }

    receiveFormalizedComment(event) {
        this.scheduleData.note = event;
        this.onInternalNoteChanged();
    }

    onVoiceTranscript(transcript) {
        if (this.scheduleData.note) {
            this.scheduleData.note += ' ' + transcript;
        } else {
            this.scheduleData.note = transcript;
        }
        this.onInternalNoteChanged();
    }

    resetMeeting() {
        this.meetingChanged();
    }
}
